import { render } from "./ConfirmEmailTemplate.vue?vue&type=template&id=5e6632c4&ts=true"
import script from "./ConfirmEmailTemplate.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__